import { render, staticRenderFns } from "./newsCateAdd.vue?vue&type=template&id=2f9ab57d&scoped=true&"
import script from "./newsCateAdd.vue?vue&type=script&lang=js&"
export * from "./newsCateAdd.vue?vue&type=script&lang=js&"
import style0 from "./newsCateAdd.vue?vue&type=style&index=0&id=2f9ab57d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9ab57d",
  null
  
)

export default component.exports